/**
 * The shared blue ripple "thinking" dot used by the agent loading indicators (TD-2334).
 * Presentational and decorative (aria-hidden), no props; styled via
 * .agent-loading-ripple / .ripple-circle.
 */
const AgentLoadingRipple = () => (
  <div className="agent-loading-ripple" aria-hidden="true">
    <div className="ripple-circle"></div>
    <div className="ripple-circle"></div>
    <div className="ripple-circle"></div>
  </div>
);

export default AgentLoadingRipple;
